import StoreFront from "./pages/Storefront";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { useEffect, useState } from "react";
import ProductApp from "./pages/add_product_app";

function App() {
  const [adminPage, setAdminPage] = useState("/login");

  useEffect(() => {
    const token = localStorage.getItem("adminToken");

    if (token) {
      setAdminPage("/dashboard");
    }
  }, []);

  if (window.location.pathname.startsWith("/admin")) {
    switch (adminPage) {

      case "/dashboard":
        let component = null;

        switch (window.location.pathname) {

          case "/admin/add_product_app":
            const token = localStorage.getItem("adminToken");

            if (token) {
              component = <ProductApp />;
            }
            break;

          case "/admin":
            component = null;
            break;

          default:
            component = <h1>failed to load</h1>;
        }

        return (
          <>
            <AdminDashboard setAdminPage={setAdminPage} />

            <div className="container">
              {component}
              <a href="/admin/add_product_app">add products</a>
            </div>
          </>
        );

      case "/login":
      default:
        return <AdminLogin setAdminPage={setAdminPage} />;
    }
  }

  return <StoreFront />;
}

export default App;